"use strict";
var accordion_component_1 = require('./accordion/accordion.component');
var accordion_group_component_1 = require('./accordion/accordion-group.component');
var accordion_component_2 = require('./accordion/accordion.component');
exports.AccordionComponent = accordion_component_2.AccordionComponent;
var accordion_group_component_2 = require('./accordion/accordion-group.component');
exports.AccordionPanelComponent = accordion_group_component_2.AccordionPanelComponent;
exports.ACCORDION_DIRECTIVES = [accordion_component_1.AccordionComponent, accordion_group_component_1.AccordionPanelComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/accordion.js
 ** module id = 681
 ** module chunks = 0
 **/